import FYCQueryBuilder, { FYCQuery } from "./FYCQueryBuilder";
import { useGeolocation } from "src/utils/localization/geolocation/GeolocationContext";
import { cruiseSearchIndexName } from "src/algolia";
import { useMemo } from "react";

type UseFYCReturnValues =
  | {
      filterDefaultSearch: FYCQuery;
      localizedSearchIndexName: string;
    }
  | {
      filterDefaultSearch: FYCQuery;
      localizedSearchIndexName: undefined;
    };

export function useFYC(initialQuery: FYCQuery | undefined): UseFYCReturnValues {
  const geolocation = useGeolocation();
  const localizedSearchIndexName = geolocation.algoliaArea
    ? cruiseSearchIndexName(geolocation.algoliaArea)
    : undefined;

  const filterDefaultSearch = useMemo(() => {
    const queryBuilder = new FYCQueryBuilder(initialQuery);
    queryBuilder.onlyFutureCruises();

    if (process.env.GATSBY_SHOW_ALL_FUTURE_CRUISES != "true")
      queryBuilder.onlyVisibleCruises();
    return queryBuilder.generate();
  }, [initialQuery]);

  if (!localizedSearchIndexName)
    return {
      filterDefaultSearch,
      localizedSearchIndexName: undefined
    };

  return {
    filterDefaultSearch,
    localizedSearchIndexName
  };
}
